import addMoneyMask from "../../../../utils/addMoneyMask";
import CardTag from "../cardTag";
import PlanCardTitle from "../planCardTitle";
import CardText from "../CardText";
import { getTagColor, getCardText, getTagText } from "./componentUtils";

const PlanCard = ({
  activeSlide,
  index,
  plan,
  selectedPlanID,
  selectedBemID,
  shouldBeFullHeight,
  options,
  updateCheckStatus,
}) => {
  return (
    <div
      className={`carousel-plan-item ${
        activeSlide === index ? "" : "carousel-plan-item--unavailable"
      }`}
    >
      <PlanCardTitle plan={plan} />
      {plan.planosTipos.map((tipo, index) => (
        <label
          className={`carousel-plan-checkbox
            ${
              selectedPlanID === tipo.planoID && tipo.bemId === selectedBemID
                ? "carousel-plan-checkbox--selected"
                : ""
            }
            ${
              shouldBeFullHeight(options) ? "carousel-plan-checkbox--full" : ""
            }`}
          key={index}
        >
          <div className="carousel-plan-box">
            <input
              type="checkbox"
              onChange={(event) => {
                updateCheckStatus(tipo.planoID, tipo.bemId);
              }}
              checked={
                tipo.planoID === selectedPlanID && tipo.bemId === selectedBemID
              }
            />
            <span className="carousel-plan-checkmark"></span>
          </div>
          <div className="carousel-plan-content">
            <div className="carousel-chips-container">
              <CardTag
                text={getTagText(tipo.name)}
                backgroundColor={getTagColor(tipo.name).backgroundColor}
                textColor={getTagColor(tipo.name).textColor}
                fontWeight={getTagColor(tipo.name).fontWeight}
              />
            </div>
            <div className="carousel-plan-strong">
              {addMoneyMask(tipo.valorParcela)}
              <span className="carousel-plan-message"> mensais</span>
            </div>
            <span className="carousel-plan-description">
              Taxa: {tipo.planoTaxaAdmTotal}%
            </span>

            <CardText text={getCardText(tipo.name)} />
          </div>
        </label>
      ))}
    </div>
  );
};

export default PlanCard;
